import { Base } from "../../framework/base";
import { ITaskValidationRowCol, TaskValidationRowCol } from "./taskValidationRowCol";

export interface ITaskValidationRow {
    id: string;
    cols: ITaskValidationRowCol[];
}

export class TaskValidationRow implements ITaskValidationRow {
    id: string;
    cols: TaskValidationRowCol[];

    constructor();
    constructor(obj: TaskValidationRow);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.cols = Base.getTypedArray(obj ? obj.cols : null, TaskValidationRowCol);
    }
}